import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-vagrant',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Vagrant icon</title><path d="M3.556 0L.392 1.846V4.11l7.124 17.3L11.998 24l4.523-2.611 7.083-17.345V1.848l.004-.002L20.44 0l-5.274 3.087v2.111l-3.168 7.384-3.164-7.384V3.109l-.017-.008.017-.01z"/></svg>`,
    styles: []
})
export class SimpleIconsVagrantComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#1563FF';
    @Input() className: string = 'simple-icons-vagrant'
    constructor() {}
    ngOnInit(): void {}
}
